import * as React from 'react';
import { Paper } from '@mui/material';
import { MainPadding } from '../../components/MainPadding';
import { Breadcumb } from '../../components/Breadcumb';
import { CreateOrUpdateFormProps, CreateOrUpdateForm } from './CreateOrUpdateForm';
import { useNavigate } from 'react-router-dom';

interface InjectedRouterProps {
    navigate: ReturnType<typeof useNavigate>;
}

type Props = CreateOrUpdateFormProps & InjectedRouterProps;

class CreateOrUpdateDumb extends React.Component<Props>{
    render(){
        return (<MainPadding style={{maxWidth: '42em'}}>
            <Breadcumb items={[
                { label:"Quality Check Config", to:`/quality-check-configs/` },
                { label: "New Config" }
            ]} /><br />

            <Paper style={{padding:16}}>
                <CreateOrUpdateForm {...this.props} onSave={()=>this.props.navigate('/quality-check-configs/')} />
            </Paper>
        </MainPadding>);
    }
}

export function CreateOrUpdate(props: CreateOrUpdateFormProps){
    const navigate = useNavigate();
    return <CreateOrUpdateDumb {...props} navigate={navigate} />;
}
